import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';
import { getFormChild } from '../helpers/getFormChild';
import { FormSettingsControls, IFormMeta, IFormStepProps } from '../types/IFormSettings';
import { controlSelector, formKeySelector } from '../selectors/formBuilder.selector';
import {
    setFormStepAction,
    validateFormDataAction,
    prepareFormDataIfValidAction,
    calculateProgressAction,
} from '../actions/formActions';
import { ContentWithScripts } from './ContentWithScripts';
import { scrollToRootOrError, getTrackingScriptNode } from '../helpers/allHelpers';
// import { Calculator } from '../components';
// import { ICalculatorProps } from '../types';

interface FormStepProps {
    formName: string;
    controls: FormSettingsControls[];
}

// const calculator = document.getElementById('calculator');
// const calculatorSettings = JSON.parse(
//     calculator?.dataset.json ?? (null as any),
// ) as ICalculatorProps;

function FormStep({ controls, formName }: FormStepProps) {
    const { formMeta = {} as IFormMeta } = useSelector(formKeySelector(formName, 'initialSettings')) || {};
    const totalSteps = controls.length;
    const dispatch = useDispatch();
    const [elToRender, setElToRender] = useState<Element | null>(null);
    const step = useSelector(formKeySelector(formName, 'step')) ?? 0;
    const { grid, backButton, nextButton, controls: stepControls } = (controls[step] ?? {}) as IFormStepProps;
    const [renderGrid, setRenderGrid] = useState<string>(grid);
    const controlsToRender = stepControls?.map((control, i) => getFormChild(control, formName, i));
    const amount = useSelector(controlSelector(formName, 'amount'));
    const repaymentPeriod = useSelector(controlSelector(formName, 'repaymentPeriod'));

    useEffect(() => {
        setElToRender(null);
        setRenderGrid(grid);

        // a workaround for IE 11
        setTimeout(() => {
            const el = document.getElementsByClassName('form-application-step')[0];
            setElToRender(el);
        }, 10);
    }, [grid]);

    useEffect(() => {
        setTimeout(() => {
            dispatch(calculateProgressAction(formName));
        }, 100);
    }, [dispatch, formName, step]);

    const trackingScript = () => {

        if (formMeta?.market !== 'Lithuania' || step > 0) {
            return;
        }

        const eventName = formMeta?.product === 'LtuRefin' ? 'refinansavimas-testi' : 'oldform-testi';
        const trackingScript =
            'window.dataLayer = window.dataLayer || [];' +
            'window.dataLayer.push({ ' +
            `'event': '${eventName}',` +
            `'Product': '${formMeta?.product}',` +
            `'Amount': '${amount.value}',` +
            `'RepaymentPeriod': '${repaymentPeriod.value}',` +
            '});';

        const newScript = getTrackingScriptNode(trackingScript);
        document.body.appendChild(newScript);
    }

    const onBackClick = (e: any) => {
        if (step <= 0) {
            window.history.back();
            return;
        }

        scrollToRootOrError(e);
        dispatch(setFormStepAction(formName, step - 1));
    };

    const onNextClick = (e: any) => {
        trackingScript();
        scrollToRootOrError(e);
        dispatch(validateFormDataAction(formName));
        dispatch(prepareFormDataIfValidAction(formName));
    };

    return (
		<>
			<div className="stepGrid">
				<ContentWithScripts html={renderGrid} />
			</div>
			{elToRender &&
				createPortal(
					<div className="stepForm">
						{controlsToRender}
						{/* {(step === 0 && calculatorSettings) && <Calculator {...calculatorSettings} renderUnderParent formName={formName} />} */}
						<div className="container-fluid fieldset">
							<Row>
								<Col xs={12} className="buttons">
									{backButton && (
										<Button
											className="back"
											variant="info"
											onClick={onBackClick}>
											{backButton}
										</Button>
									)}
									{nextButton && (
										<Button
											className="next"
											variant={
												step + 1 === totalSteps
													? 'primary'
													: 'secondary'
											}
											onClick={onNextClick}>
											{nextButton}
										</Button>
									)}
								</Col>
							</Row>
						</div>
					</div>,
					elToRender,
				)}
		</>
	)
}

export default FormStep;
